"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteService = exports.FavoriteSortFlags = exports.FavoriteNotifyFlags = void 0;
const service_1 = require("./service");
const favorite_1 = require("../models/favorite");
Object.defineProperty(exports, "FavoriteNotifyFlags", { enumerable: true, get: function () { return favorite_1.FavoriteNotifyFlags; } });
Object.defineProperty(exports, "FavoriteSortFlags", { enumerable: true, get: function () { return favorite_1.FavoriteSortFlags; } });
const favoriteMapper_1 = require("../utils/favoriteMapper");
class FavoriteService extends service_1.Service {
    /**
     * Список избранных тем и разделов.
     * Команда: "mf" (FAVORITES_LIST) — 26221
     * @param offset Смещение
     * @param limit Лимит (по умолчанию 20)
     * @param flags Сортировка: UNREAD_FIRST (1), BY_NAME (4), REVERSE (8)
     */
    async getFavorites(offset = 0, limit = 20, flags = 0) {
        const response = await this.transport.send('mf', [offset, limit, flags]);
        this.checkError(response, 'mf');
        return favoriteMapper_1.FavoriteMapper.mapFavoritesResponse(response.data);
    }
    /**
     * Отметить всё избранное прочитанным.
     * Команда: "fm" (FORUM_MODIFY), ActionID 21 — как в официальном клиенте (A0.java).
     * Request: [21, [-1], 32, 8, ""] (A0.java: q(-1, null, 21, 32, 8, ...))
     */
    async markAllAsRead() {
        const response = await this.transport.send('fm', [21, [-1], 32, 8, '']);
        this.checkError(response, 'fm');
    }
    /**
     * Отметить один элемент избранного прочитанным.
     * Тема: fm action 11 — [11, [topicId], 32, 0, ""] (API_Reference, A0.java action 33).
     * Раздел: fm action 21 — [21, [forumId], 32, 0, ""] (C0.java action 33).
     */
    async markAsRead(type, id) {
        const response = type === favorite_1.FavoriteItemType.FORUM
            ? await this.transport.send('fm', [21, [id], 32, 0, ''])
            : await this.transport.send('fm', [11, [id], 32, 0, '']);
        this.checkError(response, 'fm');
    }
    favModifyAction(type) {
        return type === favorite_1.FavoriteItemType.FORUM ? 21 : 11;
    }
    /**
     * Настройка уведомлений избранного.
     * fm action 15 — [15, [id], notifyFlags, 0, ""] (A0.java actions 51–54).
     */
    async setNotifyFlags(type, id, notifyFlags) {
        void type;
        const response = await this.transport.send('fm', [15, [id], notifyFlags, 0, '']);
        this.checkError(response, 'fm');
    }
    /**
     * Добавить / убрать из «Важных».
     * fm 11/21 — param 9 (важное) или 8 (не важное) (A0.java actions 4–5).
     */
    async setImportant(type, id, important) {
        const action = this.favModifyAction(type);
        const param = important ? 9 : 8;
        const response = await this.transport.send('fm', [action, [id], param, 0, '']);
        this.checkError(response, 'fm');
    }
    /**
     * Удалить из избранного (отписаться).
     * fm 11/21 — [action, [id], 8, 0, ""] (A0.java action 1).
     */
    async remove(type, id) {
        const action = this.favModifyAction(type);
        const response = await this.transport.send('fm', [action, [id], 8, 0, '']);
        this.checkError(response, 'fm');
    }
}
exports.FavoriteService = FavoriteService;
